export default {
  WAITING: 'WAITING',
  COMPLETED: 'COMPLETED',
};
